// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"898bb65d","70":"898bb65d","134":"898bb65d","351":"898bb65d","517":"898bb65d","602":"898bb65d","916":"898bb65d"}[chunkId] + ".chunk.css";
};